// extracted by mini-css-extract-plugin
module.exports = {"NarrowStageWithLogo":"NarrowStageWithLogo-module__NarrowStageWithLogo___2J82S"};